module.exports = __webpack_public_path__ + "media/images/2_3_5-cc29a594a93e7ebb28a09965ca497e80.png";